// Requires Cookie.js.
// Activate a drop down list of counties
// 1> Remember county preference in cookie
// 2> Restore county preference from cookie
// 3> Modify clickthroughs to 211 resource links accordingly.
; (function($) {
    var $cookieKey = "county211";
    var Cookies = require('js-cookie');

    $.fn.county211 = function(options) {
        var $opts = jQuery.extend({}, jQuery.fn.county211.defaults, options);

        return this.each(function() {
            var $this = $(this);

            // get county preference from cookie
            var strCounty = $.fn.county211.getCounty();
            if (0 == strCounty.length)
                strCounty = "-1";

            // set the current selection based on the cookie
            $this.val(strCounty);

            // remember changes in cookie
            $this.change(function(e) {
                var $val = $this.val();
                if ("-1" == $val)
                    Cookies.set($cookieKey, null, { path: '/' });  // clear
                else
                    Cookies.set($cookieKey, $val, { expires: 365, path: '/' });
            });

            // attach click handler to service links
            $($opts.serviceLinkSelector).bind("click", function(e) {
                var $link = $(this);
                $.fn.county211.dispatch($link, $opts, $.fn.county211.getCounty());
                return false;
            });
        });
    };

    $.fn.county211.dispatch = function($link, $opts, $dest) {
        var $href = $link.attr("href");
        if ($dest.length > 0) {
            if ("param" == $opts.serviceLinkModel) {
                $href += "&" + $opts.serviceLinkKey + "=" + $dest;
            } else if ("interpose" == $opts.serviceLinkModel) {
                $href = $href.replace($opts.serviceLinkInterposeBefore, "/" + $dest + $opts.serviceLinkInterposeBefore);
            } else if ("interposeAfter" == $opts.serviceLinkModel) {
                $href = $href.replace($opts.serviceLinkInterposeAfter, $opts.serviceLinkInterposeAfter + "/" + $dest)
            }
        }

        window.open($href, "_blank");
    };

    $.fn.county211.getCounty = function() {
        var strCounty = Cookies.get($cookieKey);
        if (!strCounty)
            strCounty = "";
        return strCounty;
    };

    $.fn.county211.defaults = {
        serviceLinkSelector: ".styleServicesLink",
        serviceLinkKey: "geo_county",
        serviceLinkModel: "param",
        serviceLinkInterposeBefore: "/topics",
        serviceLinkInterposeAfter: "/Public"
    };
})(jQuery);